import * as actions from './indicators.actions'

const initialState = {
  userData: {
    updatingData: 0,
    turn: 1,
    coins: 0,
    antimatter: 0,
    settlers: 0,
    happiness: 0,
    energy: 0,
    food: 0,
    home: 0,
    oxygen: 0,
    water: 0,
    settlersOld: 0,
    energyOld: 0,
    foodOld: 0,
    homeOld: 0,
    oxygenOld: 0,
    waterOld: 0,
    cityLevel: 1,
    counters: {},
  },
  visitorData: null,
  displayingType: null,
}

const actionsMap = {
  [actions.SET_USER_DATA]: (state, action) => {
    return {
      ...state,
      userData: {
        ...state.userData,
        ...action.data,
      },
    }
  },
  [actions.SET_DISPLAYING_TYPE]: (state, action) => {
    return {
      ...state,
      displayingType: action.data,
    }
  },
  [actions.SET_VISITOR_INDICATORS]: (state, action) => {
    const indicators = action.data

    return {
      ...state,
      visitorData: indicators,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
